<template>
  <div>
    <v-card>
      <v-expansion-panels width>
        <v-expansion-panel>
          <v-expansion-panel-header>Site Visit</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list dense>
              <v-list-item v-if="commentsServior.length==0">
                <v-list-item-content>No Data Available</v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list dense>
              <v-list-item v-for="item in commentsServior" :key="item.commentid" @click.stop>
                <v-list-item-content>
                  <v-list-item-title v-text="item.commenton"></v-list-item-title>
                  <v-textarea v-html="item.commenttext"></v-textarea>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Call Summary</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list dense>
              <v-list-item v-if="commentsServior.length==0">
                <v-list-item-content>No Data Available</v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list dense>
              <v-list-item v-for="item in callSummery" :key="item.commentid" @click.stop>
                <v-list-item-content>
                  <v-list-item-title v-text="item.commenton"></v-list-item-title>
                  <v-textarea v-html="item.commenttext"></v-textarea>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </div>
</template>
<script>
export default {
  props: ["commentsServior", "callSummery"],
  created: function() {
    console.log(this.commentsServior);
    console.log(this.callSummery);
  },
  data() {
    return {};
  }
};
</script>